import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import RolesViewModel from "viewModels/users/roles/rolesViewModel";
import ListView from "../../common/list";

const RolesView: ViewComponent<RolesViewModel> = observer(({ vm }) => {
  return (
    <ListView
      vm={vm}
      columns={[
        { title: vm.translateAttribute("id"), property: "id" },
        { title: vm.translateAttribute("name"), property: "name" },
        { title: vm.translateAttribute("usersInRoleCount"), property: "usersInRoleCount" },
      ]}
    />
  );
});

registerView(RolesView, RolesViewModel);
